import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addLocation, editLocation, removeLocation } from 'FRONTEND/reducers/locationSlice';
import i18n from 'FRONTEND/utils/i18n';

const LocationForm = ({ open, onClose, initialLocation, onLocationCreated, onLocationEdited }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.app.requestCounter[addLocation.pending.toString()] > 0);
  const [description, setDescription] = useState('');
  const [cityAdress, setCityAdress] = useState('');

  useEffect(() => {
    if (initialLocation) {
      setDescription(initialLocation.description);
      setCityAdress(initialLocation.address.city);
    } else if (description && cityAdress) {
      resetLocationForm();
    }
  }, [initialLocation]);

  const handleConfirm = async() => {
    onClose();
    if (initialLocation) {
      const resultAction = await dispatch(editLocation({ ...initialLocation, description, address: { city: cityAdress } }));
      if (editLocation.fulfilled.match(resultAction)) {
        const updatedLoc = resultAction.payload;
        onLocationEdited?.(updatedLoc);
      }
    } else {
      const resultAction = await dispatch(addLocation({ description, address: cityAdress }));
      if (addLocation.fulfilled.match(resultAction)) {
        const newLoc = resultAction.payload.location;
        onLocationCreated?.(newLoc);
      }
    }
    resetLocationForm();
  };

  const handleDelete = () => {
    dispatch(removeLocation({ locationId: initialLocation.id }));
    onClose();
    resetLocationForm();
  };

  const resetLocationForm = () => {
    setDescription('');
    setCityAdress('');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        component: 'form',
        onSubmit: (event) => {
          event.preventDefault();
          handleConfirm();
          onClose();
        },
      }}
    >
      <DialogTitle variant='h5'>{initialLocation ? i18n._('Edit location') : i18n._('Create a new location')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          label={i18n._('Location')}
          type='text'
          fullWidth
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          disabled={isLoading}
        />
        <TextField
          margin='dense'
          label={i18n._('Address')}
          type='text'
          fullWidth
          value={cityAdress}
          onChange={(e) => setCityAdress(e.target.value)}
          disabled={isLoading}
        />
      </DialogContent>
      <DialogActions>
        {initialLocation && (
          <Button
            startIcon={<DeleteIcon />}
            color='error'
            variant='outlined'
            onClick={handleDelete}
            disabled={isLoading}
          >
            {i18n._('Delete')}
          </Button>
        )}
        <Button onClick={onClose} variant='outlined' disabled={isLoading}>
          {i18n._('Cancel')}
        </Button>
        <Button
          color='primary'
          variant='contained'
          disabled={!description || !cityAdress || isLoading}
          startIcon={<DoneIcon />}
          type='submit'
        >
          {initialLocation ? i18n._('Validate') : i18n._('Create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationForm;
